/** API route map: URLS.Controller.Employee */
export const Employee = {
      Name: 'Employee/',
      GetZayZoonEmployeeWidget: 'get-zayzoon-employee-widget',
      GetAll: 'employees',
      GetAllMultiStatusEmployee: 'multi-status-employee',
      GetProfileSummary: 'get-header-summary',
      GetProfileSummaryEnrollment: 'get-header-summary-enrollment',
      GetEmpDetailsById: 'get-personal-details',
      GetEmpDetailsByIdEmployee: 'get-personal-details-employee',
      GetEmployeeEnrollment: 'get-employee-enrollment',
      AddEmployee: 'add-employee',
      AddOnboardingEmployee: 'add-onboarding-employee',
      UpdateEmployee: 'update-employee',
      // EN-29808 — ported for Employee Onboarding; PEO calls this under the Employee
      // controller too. (A same-named key exists under Benefits further down in this file,
      // apparently misplaced there — left untouched in case other code already depends on it.)
      getEmploymentTypeAnonymous: 'get-employment-type-anonymous',
      PatchEmployeeDetail: 'patch-personal-details',
      PatchEmployeeDetailEnrollment: 'patch-personal-details-enrollment',
      PatchEmployeeDetailBenefitEnrollment: 'patch-personal-details-benefit-enrollment',
      PatchEmployeeDaysAvilableDetail: 'patch-available-days',
      PatchEmployeeStatus: 'patch-employee-status',
      GetPathCustomTemplate: 'get-path-employee',
      Tiles: 'tiles',
      UpdateEmployeeProfileImage: 'update-employee-profile-image',
      GetAllEmployeesBoardView: 'employees-board-view',
      Placements: 'get-placements',
      EmployeePtoPolicies: 'get-employee-assigned-policies',
      AddEmployeePtoRequest: 'add-employee-paid-time-off',
      GetPtoRequests: 'get-all-employee-pto-requests',
      GetPtoRequestsList: 'get-all-employee-pto-requests-list',
      addPtoRequestComment: 'add-pto-request-comment',
      GetPtoRequestComment: 'get-paid-time-comment',
      EmployeePtoRequest: 'get-all-pto-requests',
      PatchPtoRequestStatus: 'patch-pto-request-status',
      EmployeePayStubs: 'employee-paystubs',
      EmployeePayStubsTilesData: 'employee-paystubs-tiles-data',
      EmployeePayStubDetail: 'employee-paystub-detail',
      UpdateEnrollmentLock: 'update-enrollment-lock',
      SendEnrollment: 'send-enrollment',
      AddPath: 'get-path-employee',
      UpdateEmployeeBillingDetails: 'update-employee-billing-details',
      UpdateEmployeeBillingDetailsRunPayroll: 'update-employee-billing-details-runpayrol',
      GetEmployeeDetailsById: 'get-all-employee',
      AddPathMessage: 'get-path-message-employee',
      UploadPaystub: 'upload-paystub',
      GetEmployeeById: 'get-employee-by-id',
      EmployeeTerminationAssociation: 'employee-termination-association',
      GetBriefSummary: 'get-brief-summary',
      EmployeesAtive: 'employees-active',
      GetAllGarnishmentCheck: 'get-all-garnishment-check',
      GetAllW2FormByEmployee: 'get-w2-by-employee',
      GetAll1099FormByEmployee: 'get-1099-by-employee',
      GetAllLicenseCertificate: 'get-all-license-certificate',
      GetEmployeeDetailForUser: 'get-employee-details-for-user',
      PatchProfileField: 'patch-profile-field',
      ValidateEmail: 'validate-email',
      ValidateAddress: 'validate-address',
      SubmitProfileChangeRequest: 'submit-profile-change-request',
      GetProfileChangeRequests: 'get-profile-change-requests',
};
